<app-invite-new-member-dialog></app-invite-new-member-dialog>
<app-delete-team-member-dialog></app-delete-team-member-dialog>
<app-toast></app-toast>
<div class="flex flex-row h-screen items-center">
    <app-desktop-sidebar [selectedItemId]="selectedSidebarItemId" class="mobile:hidden"></app-desktop-sidebar>
    <div class="h-screen p-6 overflow-y-auto w-full flex flex-col mobile:p-2">
        <div class="flex flex-col flex-[1]">
            <app-desktop-topbar pageName="{{ 'shared.pages.settings' | transloco }}"
                class="mobile:hidden"></app-desktop-topbar>
            <app-mobile-topbar class="hidden mobile:block" [selectedItemId]="selectedSidebarItemId"></app-mobile-topbar>
            <div class="flex flex-wrap gap-6 items-center mobile:justify-evenly">
                <app-tab-button label="{{ 'shared.company_information' | transloco }}"
                    link="/settings/company"></app-tab-button>
                <app-tab-button label="{{ 'settings.button.my_profile' | transloco }}"
                    link="/settings/profile"></app-tab-button>
                <app-tab-button label="{{ 'settings.button.team' | transloco }}" [isActive]="true"
                    link="/settings/team"></app-tab-button>
                <app-tab-button label="{{ 'settings.button.billing' | transloco }}"
                    link="/settings/billing"></app-tab-button>
                <app-tab-button label="{{ 'settings.button.plans' | transloco }}"
                    link="/settings/plans"></app-tab-button>
            </div>

            <!-- Team members -->
            <div class="mt-5 flex flex-wrap gap-2 justify-between items-center">
                <div class="flex flex-col">
                    <p class="font-bold">{{ 'settings.team_members' | transloco }}</p>
                    <p class="text-neutral-1200">{{ 'settings.connect_team_member' | transloco }}</p>
                </div>
                <div class="w-[250px] h-[50px] min-w-[200px] mt-8 mb-6">
                    <app-custom-button buttonText="{{ 'settings.invite_new_members' | transloco }}" [isDisabled]="false"
                        backgroundColor="bg-primary" textColor="text-white" borderColor="border:bg-primary"
                        hoverBackgroundColor="hover:bg-primary-1200"
                        trailingIcon="assets/icons/settings/share-invite.svg"
                        (buttonClick)="openInviteNewMemberDialog()">
                    </app-custom-button>
                </div>
            </div>

            <!-- Team Members Table -->
            <div
                class="overflow-x-auto max-w-ultrawide h-[80vh] mb-4 mobile:max-w-screen overflow-y-auto border-border border-[1px] rounded-[6px] block">
                <table class="table w-full">
                    <!-- Header -->
                    <thead class="bg-primary-100 text-neutral-700 uppercase">
                        <tr class="max-h-[50px]">
                            <th class="border-b border-border px-4 py-4 font-normal">
                                {{ 'settings.table.person' | transloco }}
                            </th>
                            <th class="border-b border-border px-4 py-4 font-normal">
                                {{ 'settings.table.email' | transloco }}
                            </th>
                            <th class="border-b border-border px-4 py-4 font-normal">
                                {{ 'settings.table.role' | transloco }}
                            </th>
                            <th class="border-b border-border px-4 py-4 font-normal">
                                {{ 'settings.table.actions' | transloco }}
                            </th>
                        </tr>
                    </thead>
                    <!-- Content -->
                    <tbody>
                        <ng-container *ngFor="let teamMemberInfo of listOfTeamMembers; let i = index">
                            <tr class="max-h-[50px]">
                                <td class="border-b border-border px-4 py-4">
                                    <div class="flex flex-wrap gap-2 items-center">
                                        <div class="w-[40px] h-[40px]">
                                            <app-custom-avatar
                                                [initials]="getUserInitials(teamMemberInfo.first_name, teamMemberInfo.last_name)"
                                                [imageUrl]="teamMemberInfo.image_url"
                                                textSize="text-sm"></app-custom-avatar>
                                        </div> {{ teamMemberInfo.first_name }} {{
                                        teamMemberInfo.last_name}}
                                    </div>

                                </td>
                                <td class="border-b border-border px-4 py-4">{{ teamMemberInfo.email }}</td>
                                <td class="border-b border-border px-4 py-4">{{ getTranslatedRole(teamMemberInfo.role)
                                    }}
                                </td>
                                <td class="border-b border-border px-4 py-4"><button
                                        *ngIf="teamMemberInfo.email !== userEmail"
                                        (click)="deleteTeamMember(teamMemberInfo)">
                                        <svg width="48" height="48" viewBox="0 0 50 50"
                                            xmlns="http://www.w3.org/2000/svg">
                                            <circle cx="25" cy="25" r="24" fill="#FF0000" />

                                            <image href="assets/icons/delete.svg" x="12" y="12" height="25px"
                                                width="25px" />
                                        </svg>
                                    </button>
                                </td>

                            </tr>
                        </ng-container>
                    </tbody>
                </table>
            </div>
        </div>
        <app-custom-footer></app-custom-footer>
    </div>
</div>